"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[375],{

/***/ 85592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75228);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.11997 14.7101L12 10.8301L15.88 14.7101C16.27 15.1001 16.9 15.1001 17.29 14.7101C17.68 14.3201 17.68 13.6901 17.29 13.3001L12.7 8.7101C12.31 8.3201 11.68 8.3201 11.29 8.7101L6.69997 13.3001C6.30997 13.6901 6.30997 14.3201 6.69997 14.7101C7.08997 15.0901 7.72997 15.1001 8.11997 14.7101Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 49689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75228);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 15 15"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.34588 13.6273C8.0575 13.8656 7.63823 13.7399 7.49172 13.3958L6.78828 11.7438C7.73587 11.3939 8.62311 10.9234 9.44396 10.3744C9.44396 10.3744 9.66966 11.6436 9.38982 12.3723C9.20938 12.8421 8.73469 13.3061 8.34588 13.6273ZM3.25141 8.2087L1.60451 7.50815C1.25825 7.36086 1.1335 6.93831 1.37577 6.6505C1.69974 6.26564 2.16489 5.79794 2.63298 5.61886C3.35861 5.34125 4.62149 5.55437 4.62149 5.55437C4.07225 6.3748 3.60147 7.26158 3.25141 8.2087ZM12.8903 2.10977C12.8903 2.10977 9.90266 0.830267 6.4865 4.2453C5.1647 5.56643 4.37403 7.02028 3.861 8.29315C3.69201 8.7456 3.80668 9.24027 4.13864 9.57809L5.42423 10.857C5.75619 11.1948 6.25111 11.3034 6.70378 11.1345C8.22388 10.5552 9.6041 9.66087 10.7537 8.51033C14.1699 5.09589 12.8903 2.10977 12.8903 2.10977ZM8.62311 6.3748C8.15233 5.90426 8.15233 5.13812 8.62311 4.66758C9.09389 4.19704 9.86042 4.19704 10.3312 4.66758C10.7959 5.13812 10.802 5.90426 10.3312 6.3748C9.86042 6.84534 9.09389 6.84534 8.62311 6.3748Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.77609 10.3019C3.54971 10.0756 3.23604 9.92849 2.92949 10.0208C2.22706 10.2322 1.71542 10.8838 1.71542 11.6548L1.71542 13.361H3.42253C4.19392 13.361 4.84581 12.8496 5.05736 12.1476C5.14968 11.8412 5.00246 11.5277 4.77608 11.3014L3.77609 10.3019Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 15458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ sortGamesDefault; },
/* harmony export */   "h": function() { return /* binding */ sortGamesLaunching; }
/* harmony export */ });
/**
 * Helper to sort games
 */ var sortGamesPlaying = function(a, b) {
    // sort game where player has not lost first
    if (a.playerData.hasLost && b.playerData.hasLost) return 0;
    if (a.playerData.hasLost) return 1;
    if (b.playerData.hasLost) return -1;
    // sort game currently in progress first
    if (a.isInProgress && b.isInProgress) {
        // sort game with less remaining players count
        if (a.remainingPlayersCount === b.remainingPlayersCount) return 0;
        if (a.remainingPlayersCount < b.remainingPlayersCount) return -1;
        return 1;
    }
    if (a.isInProgress) return -1;
    if (b.isInProgress) return 1;
    // sort game currently starting first
    var isARegistering = !a.isInProgress && a.maxPlayers.toNumber() !== a.playerAddressesCount.toNumber();
    var isBRegistering = !b.isInProgress && b.maxPlayers.toNumber() !== b.playerAddressesCount.toNumber();
    if (isARegistering && !isBRegistering) return 1;
    if (isBRegistering && !isARegistering) return -1;
    if (a.playerAddressesCount === b.playerAddressesCount) return 0;
    if (a.playerAddressesCount < b.playerAddressesCount) return 1;
    if (a.playerAddressesCount > b.playerAddressesCount) return -1;
    if (a.remainingPlayersCount === b.remainingPlayersCount) return 0;
    if (a.remainingPlayersCount < b.remainingPlayersCount) return 1;
    if (a.remainingPlayersCount > b.remainingPlayersCount) return -1;
    return 0;
};
var sortGamesDefault = function(a, b) {
    // sort game where user is playing first
    if (a.userData.isPlaying && b.userData.isPlaying) return sortGamesPlaying(a, b);
    if (a.userData.isPlaying) return -1;
    if (b.userData.isPlaying) return 1;
    if (a.isInProgress && b.isInProgress) {
        if (a.remainingPlayersCount === b.remainingPlayersCount) return 0;
        if (a.remainingPlayersCount < b.remainingPlayersCount) return -1;
        return 1;
    }
    if (a.isInProgress) return -1;
    if (b.isInProgress) return 1;
    // sort game currently starting first
    var isARegistering = !a.isInProgress && a.maxPlayers.toNumber() !== a.playerAddressesCount.toNumber();
    var isBRegistering = !b.isInProgress && b.maxPlayers.toNumber() !== b.playerAddressesCount.toNumber();
    if (isARegistering && !isBRegistering) return 1;
    if (isBRegistering && !isARegistering) return -1;
    // sorting game paused last
    if (a.isPaused && b.isPaused) return 0;
    if (a.isPaused) return 1;
    if (b.isPaused) return -1;
    if (a.playerAddressesCount === b.playerAddressesCount) return 0;
    if (a.playerAddressesCount < b.playerAddressesCount) return 1;
    if (a.playerAddressesCount > b.playerAddressesCount) return -1;
    if (a.remainingPlayersCount === b.remainingPlayersCount) return 0;
    if (a.remainingPlayersCount < b.remainingPlayersCount) return 1;
    if (a.remainingPlayersCount > b.remainingPlayersCount) return -1;
    return 0;
};
var sortGamesLaunching = function(a, b) {
    if (a.isPaused && b.isPaused) return 0;
    if (a.isPaused) return 1;
    if (b.isPaused) return -1;
    if (a.userData.isPlaying) return 1;
    if (b.userData.isPlaying) return -1;
    if (a.isInProgress && b.isInProgress) return 0;
    if (a.isInProgress) return 1;
    if (b.isInProgress) return -1;
    if (a.playerAddressesCount === b.playerAddressesCount) return 0;
    if (a.playerAddressesCount < b.playerAddressesCount) return 1;
    if (a.playerAddressesCount > b.playerAddressesCount) return -1;
    return 0;
};


/***/ }),

/***/ 8263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_GameCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(94244);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(56917);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(1898);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(85592);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(3215);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(90915);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/ExpandableSectionButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c6e111d3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ExpandableSectionButton = function(param) {
    var onClick = param.onClick, _param_expanded = param.expanded, expanded = _param_expanded === void 0 ? false : _param_expanded;
    var t = (0,src/* useTranslation */.$G)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        return onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        "aria-label": t("Hide or show expandable content"),
        role: "button",
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "primary",
                bold: true,
                children: expanded ? t("Hide") : t("Details")
            }),
            expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ExpandableSectionButton_ExpandableSectionButton = (ExpandableSectionButton);

;// CONCATENATED MODULE: ./src/components/ExpandableSectionButton/index.ts


// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(98130);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(57610);
// EXTERNAL MODULE: ./node_modules/cron-parser/lib/parser.js
var parser = __webpack_require__(45855);
var parser_default = /*#__PURE__*/__webpack_require__.n(parser);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(83435);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(55601);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Error = __webpack_require__(30750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(20000);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(17257);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(61328);
// EXTERNAL MODULE: ./src/views/Games/components/GameCardButtons/Tooltip.tsx
var Tooltip = __webpack_require__(24681);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(85855);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(78602);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx + 1 modules
var useCatchTxError = __webpack_require__(210);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 2 modules
var Toast = __webpack_require__(34900);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 4 modules
var useContract = __webpack_require__(28761);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(31534);
;// CONCATENATED MODULE: ./src/views/Games/hooks/useClaimPrize.tsx












var useClaimPrize = function(gameAddress, epoch) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.claimPrize(epoch);
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed your prize.")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Claim prize for game ".concat(gameAddress, " and round ").concat(epoch),
                            translatableSummary: {
                                text: "Claim prize for game %gameAddress% and round %epoch%",
                                data: {
                                    gameAddress: gameAddress,
                                    epoch: epoch.toNumber()
                                }
                            },
                            type: "claim-prize"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        epoch,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handleClaim: handleClaim
    };
};

// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var lib_esm_bignumber = __webpack_require__(2593);
;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/ClaimButton.tsx






var ClaimButton = function(param) {
    var address = param.address, epoch = param.epoch;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useClaimPrize = useClaimPrize(address, lib_esm_bignumber/* BigNumber.from */.O$.from(epoch.toString())), isPending = _useClaimPrize.isPending, handleClaim = _useClaimPrize.handleClaim;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending;
    }, [
        address,
        isPending
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        ml: "4px",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleClaim,
        children: t("Claim Prize")
    });
};
/* harmony default export */ var GameCardButtons_ClaimButton = (ClaimButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/usePlayRound.tsx












var usePlayRound = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handlePlay = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.playRound();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully played this round.")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Play round for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Play round for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "play"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handlePlay: handlePlay
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/PlayButton.tsx





var PlayButton = function(param) {
    var address = param.address, isInTimeRange = param.isInTimeRange, isDisabled = param.isDisabled;
    var t = (0,src/* useTranslation */.$G)().t;
    var _usePlayRound = usePlayRound(address), isPending = _usePlayRound.isPending, handlePlay = _usePlayRound.handlePlay;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || !isInTimeRange || isPending || isDisabled;
    }, [
        address,
        isInTimeRange,
        isPending,
        isDisabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handlePlay,
        children: t("Play Round")
    });
};
/* harmony default export */ var GameCardButtons_PlayButton = (PlayButton);

// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
;// CONCATENATED MODULE: ./src/views/Games/hooks/useRegisterForGame.tsx













var useRegisterForGame = function(gameAddress, registrationAmount) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleRegister = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.registerForGame({
                                value: (0,lib_esm.parseEther)("".concat(registrationAmount))
                            });
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully registered for this game.")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Register for game ".concat(gameAddress, " with amount ").concat(registrationAmount),
                            translatableSummary: {
                                text: "Register for game %gameAddress% with amount %registrationAmount%",
                                data: {
                                    gameAddress: gameAddress,
                                    registrationAmount: registrationAmount.toNumber()
                                }
                            },
                            type: "register"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        registrationAmount,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handleRegister: handleRegister
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/RegisterButton.tsx





var RegisterButton = function(param) {
    var address = param.address, registrationAmount = param.registrationAmount, isDisabled = param.isDisabled;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useRegisterForGame = useRegisterForGame(address, registrationAmount), isPending = _useRegisterForGame.isPending, handleRegister = _useRegisterForGame.handleRegister;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending || isDisabled;
    }, [
        address,
        isPending,
        isDisabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleRegister,
        children: t("Register")
    });
};
/* harmony default export */ var GameCardButtons_RegisterButton = (RegisterButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/useVoteToSplitPot.tsx












var useVoteToSplitPot = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleVote = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.voteToSplitPot();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully vote to split pot.")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Vote to split pot for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Vote to split pot for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "vote-split-pot"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handleVote: handleVote
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/VoteSplitButton.tsx





var VoteSplitButton = function(param) {
    var address = param.address, isSplitOk = param.isSplitOk;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useVoteToSplitPot = useVoteToSplitPot(address), isPending = _useVoteToSplitPot.isPending, handleVote = _useVoteToSplitPot.handleVote;
    // TODO add check if remaining player count is less than 50%
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending || isSplitOk;
    }, [
        address,
        isPending,
        isSplitOk
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleVote,
        children: t("Vote To Split Pot")
    });
};
/* harmony default export */ var GameCardButtons_VoteSplitButton = (VoteSplitButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/usePauseGame.tsx












var usePauseGame = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handlePause = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.pause();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully paused the game.")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Pause game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Pause game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "pause-game"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handlePause: handlePause
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/PauseButton.tsx





var PauseButton = function(param) {
    var address = param.address, isInProgress = param.isInProgress;
    var t = (0,src/* useTranslation */.$G)().t;
    var _usePauseGame = usePauseGame(address), isPending = _usePauseGame.isPending, handlePause = _usePauseGame.handlePause;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending || isInProgress;
    }, [
        address,
        isInProgress,
        isPending
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        ml: "auto",
        width: "100%",
        variant: "secondary",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handlePause,
        children: t("Pause game")
    });
};
/* harmony default export */ var GameCardButtons_PauseButton = (PauseButton);

// EXTERNAL MODULE: ./src/views/Games/hooks/useUnpauseGame.tsx
var useUnpauseGame = __webpack_require__(39293);
;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/UnpauseButton.tsx





var UnpauseButton = function(param) {
    var address = param.address, isInProgress = param.isInProgress;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useUnpauseGame = (0,useUnpauseGame/* useUnpauseGame */.x)(address), isPending = _useUnpauseGame.isPending, handleUnpause = _useUnpauseGame.handleUnpause;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending || isInProgress;
    }, [
        address,
        isInProgress,
        isPending
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        ml: "auto",
        width: "100%",
        variant: "secondary",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleUnpause,
        children: t("Resume game")
    });
};
/* harmony default export */ var GameCardButtons_UnpauseButton = (UnpauseButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/useClaimCreatorFee.tsx












var useClaimCreatorFee = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleClaimCreatorFee = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.claimCreatorFee();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed creator fee")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Claim creator fee for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Claim creator fee for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "claim-creator-fee"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handleClaimCreatorFee: handleClaimCreatorFee
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/ClaimCreatorFeeButton.tsx







var ClaimCreatorFeeButton = function(param) {
    var address = param.address, creatorAmount = param.creatorAmount;
    var _chain_nativeCurrency;
    var t = (0,src/* useTranslation */.$G)().t;
    var chain = (0,useActiveWeb3React/* default */.Z)().chain;
    var chainSymbol = (chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "BNB";
    var _useClaimCreatorFee = useClaimCreatorFee(address), isPending = _useClaimCreatorFee.isPending, handleClaimCreatorFee = _useClaimCreatorFee.handleClaimCreatorFee;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending;
    }, [
        address,
        isPending
    ]);
    var claimAmount = parseFloat((0,lib_esm.formatEther)(creatorAmount));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        variant: "tertiary",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleClaimCreatorFee,
        children: "".concat(t("Claim creator fee"), " : ").concat(claimAmount, " ").concat(chainSymbol)
    });
};
/* harmony default export */ var GameCardButtons_ClaimCreatorFeeButton = (ClaimCreatorFeeButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/useClaimTreasuryFee.tsx












var useClaimTreasuryFee = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleClaimTreasuryFee = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.claimTreasuryFee();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed treasury fee")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Claim treasury fee for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Claim treasury fee for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "claim-treasury-fee"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    return {
        isPending: isPending,
        handleClaimTreasuryFee: handleClaimTreasuryFee
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/ClaimTreasuryFeeButton.tsx







var ClaimTreasuryFeeButton = function(param) {
    var address = param.address, treasuryAmount = param.treasuryAmount;
    var _chain_nativeCurrency;
    var t = (0,src/* useTranslation */.$G)().t;
    var chain = (0,useActiveWeb3React/* default */.Z)().chain;
    var chainSymbol = (chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "BNB";
    var _useClaimTreasuryFee = useClaimTreasuryFee(address), isPending = _useClaimTreasuryFee.isPending, handleClaimTreasuryFee = _useClaimTreasuryFee.handleClaimTreasuryFee;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending;
    }, [
        address,
        isPending
    ]);
    var claimAmount = parseFloat((0,lib_esm.formatEther)(treasuryAmount));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        variant: "tertiary",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleClaimTreasuryFee,
        children: "".concat(t("Claim treasury fee"), " : ").concat(claimAmount, " ").concat(chainSymbol)
    });
};
/* harmony default export */ var GameCardButtons_ClaimTreasuryFeeButton = (ClaimTreasuryFeeButton);

;// CONCATENATED MODULE: ./src/views/Games/hooks/useClaimAllFee.tsx












var useClaimAllFee = function(gameAddress) {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var contract = (0,useContract/* useGameV1Contract */.Lc)(gameAddress);
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, isPending = _useCatchTxError.loading;
    var handleClaimTreasuryFee = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.claimTreasuryFee();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed treasury fee")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Claim treasury fee for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Claim treasury fee for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "claim-treasury-fee"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    var handleClaimCreatorFee = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return contract.claimCreatorFee();
                        })
                    ];
                case 1:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess(t("Success!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("You have successfully claimed creator fee")
                        }));
                        addTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, receipt), {
                            hash: receipt.transactionHash
                        }), {
                            summary: "Claim creator fee for game ".concat(gameAddress),
                            translatableSummary: {
                                text: "Claim creator fee for game %gameAddress%",
                                data: {
                                    gameAddress: gameAddress
                                }
                            },
                            type: "claim-creator-fee"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchWithCatchTxError,
        contract,
        toastSuccess,
        t,
        addTransaction,
        gameAddress
    ]);
    var handleClaimAllFee = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            handleClaimTreasuryFee();
            handleClaimCreatorFee();
            return [
                2
            ];
        });
    }), [
        handleClaimTreasuryFee,
        handleClaimCreatorFee
    ]);
    return {
        isPending: isPending,
        handleClaimAllFee: handleClaimAllFee
    };
};

;// CONCATENATED MODULE: ./src/views/Games/components/GameCardButtons/ClaimAllFeeButton.tsx







var ClaimAllFeeButton = function(param) {
    var address = param.address, treasuryAmount = param.treasuryAmount, creatorAmount = param.creatorAmount;
    var _chain_nativeCurrency;
    var t = (0,src/* useTranslation */.$G)().t;
    var chain = (0,useActiveWeb3React/* default */.Z)().chain;
    var chainSymbol = (chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "BNB";
    var _useClaimAllFee = useClaimAllFee(address), isPending = _useClaimAllFee.isPending, handleClaimAllFee = _useClaimAllFee.handleClaimAllFee;
    var isDisabledButton = (0,react.useMemo)(function() {
        return !address || isPending;
    }, [
        address,
        isPending
    ]);
    var claimAmount = parseFloat((0,lib_esm.formatEther)(Number(treasuryAmount) + Number(creatorAmount)));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mt: "8px",
        width: "100%",
        ml: "auto",
        variant: "tertiary",
        disabled: isDisabledButton,
        endIcon: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
            spin: true,
            color: "currentColor"
        }) : null,
        onClick: handleClaimAllFee,
        children: "".concat(t("Claim creator and treasury fee"), " : ").concat(claimAmount, " ").concat(chainSymbol)
    });
};
/* harmony default export */ var GameCardButtons_ClaimAllFeeButton = (ClaimAllFeeButton);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/components/CardPlayerSection.tsx

function CardPlayerSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n"
    ]);
    CardPlayerSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8141544d-0"
})(CardPlayerSection_templateObject());
var CardPlayerSection = function(param) {
    var id = param.id, address = param.address, epoch = param.epoch, registrationAmount = param.registrationAmount, itemCreationAmount = param.itemCreationAmount, isInProgress = param.isInProgress, isRegistering = param.isRegistering, nextFromRange = param.nextFromRange, nextToRange = param.nextToRange, encodedCron = param.encodedCron, remainingPlayersCount = param.remainingPlayersCount, playerAddressesCount = param.playerAddressesCount, creatorAmount = param.creatorAmount, treasuryAmount = param.treasuryAmount, isPlaying = param.isPlaying, isWonLastGames = param.isWonLastGames, lastGameWonAmount = param.lastGameWonAmount, lastGameepoch = param.lastGameepoch, isPrizeClaimed = param.isPrizeClaimed, roundCount = param.roundCount, isCanVoteSplitPot = param.isCanVoteSplitPot, isInTimeRange = param.isInTimeRange, isReady = param.isReady, isPaused = param.isPaused, isCreator = param.isCreator, isAdmin = param.isAdmin, hasLost = param.hasLost, isLoosing = param.isLoosing, hasPlayedRound = param.hasPlayedRound, isSplitOk = param.isSplitOk, account = param.account;
    var _chain_nativeCurrency;
    var t = (0,src/* useTranslation */.$G)().t;
    var chain = (0,useActiveWeb3React/* default */.Z)().chain;
    var chainSymbol = (chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "BNB";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            isWonLastGames && !isPrizeClaimed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                mr: "4px",
                                children: [
                                    t("Earned"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    color: "success",
                                    fontSize: 16,
                                    children: [
                                        lastGameWonAmount.toNumber(),
                                        " ",
                                        chainSymbol
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 80,
                                    height: 18,
                                    mb: "4px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "4px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_ClaimButton, {
                                    address: address,
                                    epoch: lastGameepoch
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 80,
                                    height: 36,
                                    mb: "4px"
                                })
                            })
                        ]
                    })
                ]
            }),
            isInProgress && isPlaying && isCanVoteSplitPot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mr: "4px",
                        children: "".concat(t("Split pot"), ":")
                    }),
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    0,
                                    "/",
                                    remainingPlayersCount.toNumber()
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 80,
                                height: 36,
                                mb: "4px"
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        width: "100%",
                        height: 18,
                        mb: "4px"
                    })
                ]
            }),
            isInProgress && isPlaying && !hasLost && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            mr: "4px",
                            children: "".concat(t("Next play time"), ":")
                        }),
                        isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: nextFromRange && nextToRange && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                style: {
                                    textAlign: "right"
                                },
                                children: hasPlayedRound ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        "...",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    children: t("Already played, waiting for next draw")
                                                })
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        moment_default()(nextFromRange).isSame(moment_default()(), "day") ? "Today" : "Tomorrow",
                                        " between ",
                                        moment_default()(nextFromRange).format("hh:mm A"),
                                        " and ",
                                        moment_default()(nextToRange).format("hh:mm A")
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: "100%",
                            height: 18,
                            mb: "4px"
                        })
                    ]
                })
            }),
            !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                mt: "8px",
                width: "100%"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasLost && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mt: "20px",
                        mb: "16px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                width: "16px",
                                color: "failure",
                                style: {
                                    verticalAlign: "bottom"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "4px",
                                ml: "4px",
                                color: "failure",
                                children: t("You loose")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                width: "16px",
                                color: "failure",
                                style: {
                                    verticalAlign: "bottom"
                                }
                            })
                        ]
                    }),
                    !hasPlayedRound && isLoosing && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mt: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                width: "16px",
                                color: "failure",
                                style: {
                                    verticalAlign: "bottom"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "4px",
                                ml: "4px",
                                color: "failure",
                                children: t("Round missed")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                width: "16px",
                                color: "failure",
                                style: {
                                    verticalAlign: "bottom"
                                }
                            })
                        ]
                    }),
                    (isInProgress || !isRegistering) && !isCreator && !isAdmin && !hasLost && !(!hasPlayedRound && isLoosing) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_PlayButton, {
                        address: address,
                        isInTimeRange: isInTimeRange,
                        isDisabled: !isPlaying || isCreator || isAdmin || isPaused || hasPlayedRound
                    }),
                    isRegistering && !isCreator && !isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_RegisterButton, {
                        address: address,
                        registrationAmount: registrationAmount,
                        isDisabled: isPlaying || isCreator || isAdmin || isPaused
                    }),
                    isCanVoteSplitPot && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_VoteSplitButton, {
                        address: address,
                        isSplitOk: isSplitOk
                    }),
                    (isCreator || isAdmin) && isPaused && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/game/".concat(id, "/update"),
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    width: "100%",
                                    as: "a",
                                    id: "showGameDetails",
                                    mt: "8px",
                                    children: t("Update Game")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_UnpauseButton, {
                                address: address,
                                isInProgress: isInProgress
                            })
                        ]
                    }),
                    (isCreator || isAdmin) && !isPaused && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_PauseButton, {
                        address: address,
                        isInProgress: isInProgress
                    }),
                    isCreator && isAdmin && !!+treasuryAmount && !!+creatorAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_ClaimAllFeeButton, {
                        address: address,
                        treasuryAmount: treasuryAmount,
                        creatorAmount: creatorAmount
                    }),
                    isCreator && !isAdmin && !!+creatorAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_ClaimCreatorFeeButton, {
                        address: address,
                        creatorAmount: creatorAmount
                    }),
                    isAdmin && !isCreator && !!+treasuryAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCardButtons_ClaimTreasuryFeeButton, {
                        address: address,
                        treasuryAmount: treasuryAmount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "100%",
                as: "a",
                id: "showGameDetails",
                disabled: true,
                variant: "tertiary",
                mt: "8px",
                decorator: {
                    text: "Soon"
                },
                children: t("Show Game Details")
            })
        ]
    });
};
/* harmony default export */ var components_CardPlayerSection = (CardPlayerSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/types.ts
var variants = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    SUCCESS: "success",
    TEXTDISABLED: "textDisabled",
    TEXTSUBTLE: "textSubtle",
    BINANCE: "binance",
    FAILURE: "failure",
    WARNING: "warning"
};
var scales = {
    MD: "md",
    SM: "sm"
};

// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/theme.ts


var _obj;
var scaleVariants = (_obj = {}, (0,_define_property/* default */.Z)(_obj, scales.MD, {
    height: "28px",
    padding: "0 8px",
    fontSize: "14px"
}), (0,_define_property/* default */.Z)(_obj, scales.SM, {
    height: "24px",
    padding: "0 4px",
    fontSize: "12px"
}), _obj);
var _obj1;
var styleVariants = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, variants.PRIMARY, {
    backgroundColor: "primary"
}), (0,_define_property/* default */.Z)(_obj1, variants.SECONDARY, {
    backgroundColor: "secondary"
}), (0,_define_property/* default */.Z)(_obj1, variants.SUCCESS, {
    backgroundColor: "success"
}), (0,_define_property/* default */.Z)(_obj1, variants.TEXTDISABLED, {
    backgroundColor: "textDisabled"
}), (0,_define_property/* default */.Z)(_obj1, variants.TEXTSUBTLE, {
    backgroundColor: "textSubtle"
}), (0,_define_property/* default */.Z)(_obj1, variants.BINANCE, {
    backgroundColor: "binance"
}), (0,_define_property/* default */.Z)(_obj1, variants.FAILURE, {
    backgroundColor: "failure"
}), (0,_define_property/* default */.Z)(_obj1, variants.WARNING, {
    backgroundColor: "warning"
}), _obj1);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/StyledTag.tsx

function StyledTag_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  border-radius: 50px;\n  color: #ffffff;\n  display: inline-flex;\n  font-weight: 400;\n  white-space: nowrap;\n\n  & > svg {\n    fill: currentColor;\n  }\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    StyledTag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getOutlineStyles = function getOutlineStyles(param) {
    var outline = param.outline, theme = param.theme, tmp = param.variant, variantKey = tmp === void 0 ? variants.PRIMARY : tmp;
    if (outline) {
        var themeColorKey = styleVariants[variantKey].backgroundColor;
        var color = theme.colors[themeColorKey];
        return "\n      color: ".concat(color, ";\n      background: ").concat(theme.colors.background, ";\n      border: 2px solid ").concat(color, ";\n    ");
    }
    return "";
};
var StyledTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27ee8483-0"
}).withConfig({
    componentId: "sc-344d95d-0"
})(StyledTag_templateObject(), function(param) {
    var textTransform = param.textTransform;
    return textTransform && "text-transform: ".concat(textTransform, ";");
}, (0,index_esm/* variant */.bU)({
    prop: "scale",
    variants: scaleVariants
}), (0,index_esm/* variant */.bU)({
    variants: styleVariants
}), index_esm/* space */.Dh, index_esm/* typography */.cp, getOutlineStyles);
/* harmony default export */ var Tag_StyledTag = (null);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Tag/Tag.tsx







var Tag = function Tag(_param) /*#__PURE__*/ {
    var startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "startIcon",
        "endIcon",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(StyledTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ react.isValidElement(startIcon) && /*#__PURE__*/ react.cloneElement(startIcon, {
                mr: "0.5em"
            }),
            children,
            /*#__PURE__*/ react.isValidElement(endIcon) && /*#__PURE__*/ react.cloneElement(endIcon, {
                ml: "0.5em"
            })
        ]
    }));
};
/* eslint-disable react/default-props-match-prop-types */ Tag.defaultProps = {
    variant: "primary",
    scale: scales.MD,
    outline: false
};
/* harmony default export */ var Tag_Tag = (Tag);

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/RegistrationTag.tsx






var RegistrationTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "primary",
        style: {
            background: "none"
        },
        outline: true
    }, props), {
        children: t("Registering")
    }));
};
/* harmony default export */ var GameTags_RegistrationTag = (/*#__PURE__*/(0,react.memo)(RegistrationTag));

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(75228);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Svg/Icons/Verified.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23 12L20.56 9.21L20.9 5.52L17.29 4.7L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 12L3.44 14.79L3.1 18.49L6.71 19.31L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 12ZM9.38 16.01L7 13.61C6.61 13.22 6.61 12.59 7 12.2L7.07 12.13C7.46 11.74 8.1 11.74 8.49 12.13L10.1 13.75L15.25 8.59C15.64 8.2 16.28 8.2 16.67 8.59L16.74 8.66C17.13 9.05 17.13 9.68 16.74 10.07L10.82 16.01C10.41 16.4 9.78 16.4 9.38 16.01Z"
        })
    }));
};
/* harmony default export */ var Verified = (Icon);

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/ProgressTag.tsx






var ProgressTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "secondary",
        style: {
            background: "none"
        },
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
            width: "18px",
            color: "secondary",
            mr: "4px"
        })
    }, props), {
        children: t("In Progress")
    }));
};
/* harmony default export */ var GameTags_ProgressTag = (/*#__PURE__*/(0,react.memo)(ProgressTag));

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/StartingTag.tsx






var StartingTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "warning",
        style: {
            background: "none"
        },
        outline: true
    }, props), {
        children: t("Starting")
    }));
};
/* harmony default export */ var GameTags_StartingTag = (/*#__PURE__*/(0,react.memo)(StartingTag));

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/RocketIcon.tsx
var RocketIcon = __webpack_require__(49689);
;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/FreeTag.tsx






var FreeTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "success",
        style: {
            background: "none"
        },
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketIcon/* default */.Z, {
            width: "18px",
            color: "success",
            mr: "4px"
        })
    }, props), {
        children: t("Free")
    }));
};
/* harmony default export */ var GameTags_FreeTag = (/*#__PURE__*/(0,react.memo)(FreeTag));

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/PausedTag.tsx






var PausedTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "failure",
        style: {
            background: "none"
        },
        outline: true
    }, props), {
        children: t("Paused")
    }));
};
/* harmony default export */ var GameTags_PausedTag = (/*#__PURE__*/(0,react.memo)(PausedTag));

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/LostTag.tsx






var LostTag = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "failure",
        style: {
            background: "none"
        },
        outline: true,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
            width: "18px",
            color: "secondary",
            mr: "4px"
        })
    }, props), {
        children: t("Lost")
    }));
};
/* harmony default export */ var GameTags_LostTag = (/*#__PURE__*/(0,react.memo)(LostTag));

;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/VersionTag.tsx







var VersionTag = function(_param) {
    var versionId = _param.versionId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "versionId"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag_Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "textSubtle",
        style: {
            background: "none"
        },
        outline: true
    }, props), {
        children: t("V".concat(versionId.toNumber() + 1))
    }));
};
/* harmony default export */ var GameTags_VersionTag = (/*#__PURE__*/(0,react.memo)(VersionTag));

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(42037);
;// CONCATENATED MODULE: ./src/components/Logo/Logo.tsx







var BAD_SRCS = {};
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */ var Logo = function(_param) {
    var srcs = _param.srcs, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "srcs",
        "alt"
    ]);
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), refresh = _useState[1];
    var src = srcs.find(function(s) {
        return !BAD_SRCS[s];
    });
    if (src) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS[src] = true;
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, (0,_object_spread/* default */.Z)({}, rest));
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/components/CardHeadingSection.tsx

function CardHeadingSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    CardHeadingSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo_Logo).withConfig({
    componentId: "sc-394934b7-0"
})(CardHeadingSection_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
var CardHeadingSection_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-394934b7-1"
})(_templateObject1());
var MultiplierTag = (0,styled_components_browser_esm/* default */.ZP)(Tag_Tag).withConfig({
    componentId: "sc-394934b7-2"
})(_templateObject2());
var CardHeadingSection = function(param) {
    var id = param.id, name = param.name, epoch = param.epoch, versionId = param.versionId, chainId = param.chainId, prizepool = param.prizepool, multiplier = param.multiplier, isPaused = param.isPaused, isReady = param.isReady, isFree = param.isFree, isInProgress = param.isInProgress, isRegistering = param.isRegistering, hasLost = param.hasLost;
    // TODO GUIGUI DISPLAY itemCreationAmount
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeadingSection_Wrapper, {
        justifyContent: "space-between",
        alignItems: "center",
        mb: "12px",
        children: [
            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                    size: "40px",
                    srcs: [
                        "/images/chains/".concat(chainId, ".png")
                    ],
                    width: "48px"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                mr: "8px",
                width: 63,
                height: 63,
                variant: "circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "flex-end",
                children: [
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        textAlign: "right",
                        mb: "4px",
                        children: [
                            "#",
                            id.toNumber() + 1,
                            ".",
                            epoch.toNumber() + 1,
                            " - ",
                            name
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        mb: "4px",
                        width: 60,
                        height: 18
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mt: "4px",
                        children: [
                            isReady && hasLost && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_LostTag, {
                                mr: "4px"
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isInProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_ProgressTag, {
                                    mr: "4px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: !isRegistering && !isInProgress && !isPaused && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_StartingTag, {
                                    ml: "4px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isRegistering && !isPaused && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_RegistrationTag, {
                                    ml: "4px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            }),
                            isReady && isPaused && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_PausedTag, {
                                ml: "4px"
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: isFree && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_FreeTag, {
                                    ml: "4px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            }),
                            isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: multiplier && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiplierTag, {
                                    ml: "4px",
                                    variant: "secondary",
                                    children: "x".concat(multiplier.toNumber())
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                ml: "4px",
                                width: 42,
                                height: 28
                            }),
                            isReady && versionId && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_VersionTag, {
                                versionId: versionId,
                                ml: "4px"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardHeadingSection = (CardHeadingSection);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(90132);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(77936);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(97374);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(28161);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./src/views/Games/components/GameTags/ActionButton.tsx



function ActionButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 4px;\n"
    ]);
    ActionButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ActionButton_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0f0f29b-0"
})(ActionButton_templateObject());
var BoosterTooltip = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: t("More infos on game rules soon")
    });
};
var ActionButton = function(_param) {
    var title = _param.title, description = _param.description, button = _param.button, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "button"
    ]);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var btn = null;
    var _useTooltip = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BoosterTooltip, {}), (0,_object_spread/* default */.Z)({
        placement: "top"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = _useTooltip.targetRef, tooltip = _useTooltip.tooltip, tooltipVisible = _useTooltip.tooltipVisible;
    if (button) {
        btn = button;
    } else if (!isEmpty_default()(props)) {
        btn = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton_Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mr: "4px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    width: "20px",
                                    height: "20px"
                                })
                            }),
                            tooltipVisible && tooltip
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        fontSize: "12px",
                        children: description
                    })
                ]
            }),
            btn
        ]
    });
};
/* harmony default export */ var GameTags_ActionButton = (ActionButton);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/components/DetailsSection.tsx

function DetailsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 4px;\n"
    ]);
    DetailsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DetailsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n"
    ]);
    DetailsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DetailsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    DetailsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var DetailsSection_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9b1d41c-0"
})(DetailsSection_templateObject());
var DetailsSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9b1d41c-1"
})(DetailsSection_templateObject1());
var StyledLinkExternal = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-c9b1d41c-2"
})(DetailsSection_templateObject2());
var ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9b1d41c-3"
})(_templateObject3());
var DetailsSection = function(param) {
    var bscScanAddress = param.bscScanAddress, isReady = param.isReady, treasuryFee = param.treasuryFee, creatorFee = param.creatorFee, creator = param.creator;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameTags_ActionButton, {
                    title: "".concat(t("Game Rules")),
                    description: t("More info about Let's Fucking Game")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsSection_Container, {
                style: {
                    paddingTop: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            fontSize: "12px",
                            children: t("Treasury fee : ".concat(treasuryFee.toNumber() / 100, "%"))
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            ml: "4px",
                            width: 42,
                            height: 28
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            fontSize: "12px",
                            children: t("Creator fee : ".concat(creatorFee.toNumber() / 100, "%"))
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            ml: "4px",
                            width: 42,
                            height: 28
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                            fontSize: "12px",
                            href: creator,
                            children: t("Creator")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            ml: "4px",
                            width: 42,
                            height: 28
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        style: {
                            paddingTop: 8
                        },
                        children: isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkExternal, {
                            href: bscScanAddress,
                            children: t("View Contract")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            ml: "4px",
                            width: 42,
                            height: 28
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DetailsSection = (DetailsSection);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/components/CardContentSection.tsx

function CardContentSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin-left: 8px;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n    color: ",
        ";\n  }\n  li::marker {\n    font-size: 12px;\n  }\n"
    ]);
    CardContentSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardContentSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n"
    ]);
    CardContentSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-902efc17-0"
})(CardContentSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CardContentSection_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-902efc17-1"
})(CardContentSection_templateObject1());
var CardContentSection = function(param) {
    var registrationAmount = param.registrationAmount, prizepool = param.prizepool, prizes = param.prizes, cronHumanReadable = param.cronHumanReadable, remainingPlayersCount = param.remainingPlayersCount, playerAddressesCount = param.playerAddressesCount, maxPlayers = param.maxPlayers, isInProgress = param.isInProgress, isRegistering = param.isRegistering, isReady = param.isReady;
    var _chain_nativeCurrency;
    var t = (0,src/* useTranslation */.$G)().t;
    var chain = (0,useActiveWeb3React/* default */.Z)().chain;
    var chainSymbol = (chain === null || chain === void 0 ? void 0 : (_chain_nativeCurrency = chain.nativeCurrency) === null || _chain_nativeCurrency === void 0 ? void 0 : _chain_nativeCurrency.symbol) || "BNB";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContentSection_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        mr: "4px",
                        children: [
                            t("Prizepool"),
                            ": "
                        ]
                    }),
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketIcon/* default */.Z, {
                                m: "4px",
                                color: "success"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                bold: true,
                                color: "success",
                                fontSize: 16,
                                children: [
                                    prizepool.toNumber(),
                                    " ",
                                    chainSymbol
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                additionalStyle: {
                                    color: "success"
                                },
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            children: t("Prizepool details : ")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                            children: prizes === null || prizes === void 0 ? void 0 : prizes.map(function(prize) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        display: "inline",
                                                        color: "textSubtle",
                                                        children: "Position ".concat(prize.position.toNumber(), " will win ").concat(prize.amount.toNumber(), " ").concat(chainSymbol)
                                                    })
                                                });
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 80
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        mr: "4px",
                        children: [
                            t("Registration"),
                            ": "
                        ]
                    }),
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: registrationAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            bold: true,
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                registrationAmount.toNumber() === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: 16,
                                    children: "FREE"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: 16,
                                    children: [
                                        registrationAmount.toNumber(),
                                        " ",
                                        chainSymbol
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        display: "inline",
                                        color: "textSubtle",
                                        children: "Registration amount will be used in the game prizepool"
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 80
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        mr: "4px",
                        children: [
                            t("Players"),
                            ": "
                        ]
                    }),
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                bold: true,
                                children: [
                                    remainingPlayersCount.toNumber(),
                                    "/",
                                    maxPlayers.toNumber()
                                ]
                            }),
                            isRegistering && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    display: "inline",
                                    color: "textSubtle",
                                    children: "Game will start when ".concat(maxPlayers.toNumber(), " players have joined this game")
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 80
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    (isRegistering || isInProgress) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        mr: "4px",
                        children: [
                            t("Daily Draw"),
                            ": "
                        ]
                    }),
                    !isInProgress && !isRegistering && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        mr: "4px",
                        children: [
                            t("Game will start"),
                            ": "
                        ]
                    }),
                    isReady ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                children: t("".concat(cronHumanReadable))
                            }),
                            isRegistering && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    display: "inline",
                                    color: "textSubtle",
                                    children: "If all ".concat(maxPlayers.toNumber(), " players have joined this game up")
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 80
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardContentSection = (CardContentSection);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/GameCard.tsx


function GameCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: baseline;\n  max-width: 100%;\n  margin: 0 0 24px 0;\n  ",
        " {\n    max-width: 350px;\n    margin: 0 12px 46px;\n  }\n"
    ]);
    GameCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GameCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 24px;\n"
    ]);
    GameCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GameCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  border-top: 2px solid ",
        ";\n  overflow: hidden;\n"
    ]);
    GameCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-7421bb2c-0"
})(GameCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var GameCardInnerContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7421bb2c-1"
})(GameCard_templateObject1());
var ExpandingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7421bb2c-2"
})(GameCard_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var GameCard = function(param) {
    var game = param.game, account = param.account;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), showExpandableSection = _useState[0], setShowExpandableSection = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(""), 2), cronHumanReadable = _useState1[0], setCronHumanReadable = _useState1[1];
    var name = game.name, versionId = game.versionId, epoch = game.epoch, id = game.id, isPaused = game.isPaused, isInProgress = game.isInProgress, isRegistering = game.isRegistering, isDeleted = game.isDeleted, maxPlayers = game.maxPlayers, remainingPlayersCount = game.remainingPlayersCount, playerAddressesCount = game.playerAddressesCount, registrationAmount = game.registrationAmount, itemCreationAmount = game.itemCreationAmount, address = game.address, prizepool = game.prizepool, encodedCron = game.encodedCron, creator = game.creator, treasuryFee = game.treasuryFee, treasuryAmount = game.treasuryAmount, creatorFee = game.creatorFee, creatorAmount = game.creatorAmount, prizes = game.prizes, lastRoundWinners = game.lastRoundWinners, _game_userData = game.userData, isCreator = _game_userData.isCreator, isAdmin = _game_userData.isAdmin, isPlaying = _game_userData.isPlaying, nextFromRange = _game_userData.nextFromRange, nextToRange = _game_userData.nextToRange, isCanVoteSplitPot = _game_userData.isCanVoteSplitPot, isInTimeRange = _game_userData.isInTimeRange, isLoosing = _game_userData.isLoosing, _game_playerData = game.// TODO GUIGUI USE playerData
    playerData, playerAddress = _game_playerData.playerAddress, roundRangeLowerLimit = _game_playerData.roundRangeLowerLimit, roundRangeUpperLimit = _game_playerData.roundRangeUpperLimit, hasPlayedRound = _game_playerData.hasPlayedRound, roundCount = _game_playerData.roundCount, position = _game_playerData.position, hasLost = _game_playerData.hasLost, isSplitOk = _game_playerData.isSplitOk;
    var toggleExpandableSection = (0,react.useCallback)(function() {
        setShowExpandableSection(function(prev) {
            return !prev;
        });
    }, []);
    var timezone = "Etc/UTC";
    try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
    // noop
    }
    (0,react.useEffect)(function() {
        if (!encodedCron) return;
        try {
            var interval = parser_default().parseExpression(encodedCron, {
                tz: "Etc/UTC"
            });
            var transform = moment_default()(interval.next().toString()).format("hh:mm A");
            setCronHumanReadable("".concat(transform));
        } catch (e) {
            setCronHumanReadable("");
        }
    }, [
        encodedCron,
        timezone
    ]);
    var isReady = game.prizepool !== undefined;
    var lastGamePrize = lastRoundWinners.find(function(winner) {
        return winner.playerAddress === account;
    // TODO GUIGUI WHY playerAddress is not defined
    // return winner.playerAddress === playerAddress
    });
    var isWonLastGames = !!lastGamePrize;
    var lastGameWonAmount = isWonLastGames ? lastGamePrize.amountWon : new (bignumber_default())("0");
    var lastGameepoch = isWonLastGames ? lastGamePrize.epoch : new (bignumber_default())("0");
    var isPrizeClaimed = isWonLastGames ? lastGamePrize.prizeClaimed : true;
    // TODO GUIGUI use RoundProgress to display a progressBar if necessary
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        isActive: !isDeleted,
        isFailure: hasLost,
        isWarning: !isRegistering && !isInProgress,
        isSuccess: isPlaying,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GameCardInnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardHeadingSection, {
                        id: id,
                        name: name,
                        epoch: epoch,
                        versionId: versionId,
                        chainId: chainId,
                        prizepool: prizepool,
                        multiplier: registrationAmount.toNumber() !== 0 ? prizepool.dividedBy(registrationAmount) : null,
                        isPaused: isPaused,
                        isReady: isReady,
                        isFree: registrationAmount.toNumber() === 0,
                        isInProgress: isInProgress,
                        isRegistering: isRegistering,
                        hasLost: hasLost
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardContentSection, {
                        registrationAmount: registrationAmount,
                        prizepool: prizepool,
                        maxPlayers: maxPlayers,
                        remainingPlayersCount: remainingPlayersCount,
                        playerAddressesCount: playerAddressesCount,
                        cronHumanReadable: cronHumanReadable,
                        isReady: isReady,
                        prizes: prizes,
                        isInProgress: isInProgress,
                        isRegistering: isRegistering
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardPlayerSection, {
                        id: id,
                        address: address,
                        epoch: epoch,
                        isInProgress: isInProgress,
                        isRegistering: isRegistering,
                        nextFromRange: nextFromRange,
                        nextToRange: nextToRange,
                        encodedCron: encodedCron,
                        remainingPlayersCount: remainingPlayersCount,
                        playerAddressesCount: playerAddressesCount,
                        isPlaying: isPlaying,
                        isWonLastGames: isWonLastGames,
                        lastGameWonAmount: lastGameWonAmount,
                        lastGameepoch: lastGameepoch,
                        isPrizeClaimed: isPrizeClaimed,
                        isCanVoteSplitPot: isCanVoteSplitPot,
                        isInTimeRange: isInTimeRange,
                        itemCreationAmount: itemCreationAmount,
                        registrationAmount: registrationAmount,
                        creatorAmount: creatorAmount,
                        treasuryAmount: treasuryAmount,
                        roundCount: roundCount,
                        isReady: isReady,
                        isPaused: isPaused,
                        isCreator: isCreator,
                        isAdmin: isAdmin,
                        hasLost: hasLost,
                        isLoosing: isLoosing,
                        hasPlayedRound: hasPlayedRound,
                        isSplitOk: isSplitOk,
                        account: account
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExpandingWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableSectionButton_ExpandableSectionButton, {
                        onClick: toggleExpandableSection,
                        expanded: showExpandableSection
                    }),
                    showExpandableSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DetailsSection, {
                        isReady: isReady,
                        bscScanAddress: (0,utils/* getBlockExploreLink */.C)(address, "address", chainId),
                        treasuryFee: treasuryFee,
                        creatorFee: creatorFee,
                        creator: (0,utils/* getBlockExploreLink */.C)(creator, "address", chainId)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GameCard_GameCard = (GameCard);

;// CONCATENATED MODULE: ./src/views/Games/components/GameCard/index.tsx

/* harmony default export */ var components_GameCard = (GameCard_GameCard);


/***/ }),

/***/ 43474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ GamesContext; },
  "P": function() { return /* binding */ GamesPageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(56917);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(83435);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(1898);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(20000);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(64978);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(17257);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(74648);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(35751);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(64030);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(67552);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(45070);
// EXTERNAL MODULE: ./src/state/games/hooks.ts + 3 modules
var hooks = __webpack_require__(98823);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(9360);
;// CONCATENATED MODULE: ./src/hooks/useIntersectionObserver.ts



var useIntersectionObserver = function() {
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), observerRefElement = _useState[0], setObserverRefElement = _useState[1];
    var intersectionObserverRef = (0,react.useRef)(null);
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isIntersecting = _useState1[0], setIsIntersecting = _useState1[1];
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var isSupported =  true && window.IntersectionObserver;
        if (isSupported) {
            if (!intersectionObserverRef.current && observerRefElement) {
                var checkObserverIsIntersecting = function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
                    setIsIntersecting(entry.isIntersecting);
                };
                intersectionObserverRef.current = new window.IntersectionObserver(checkObserverIsIntersecting, {
                    rootMargin: "0px",
                    threshold: 1
                });
                intersectionObserverRef.current.observe(observerRefElement);
            }
            if (intersectionObserverRef.current && !observerRefElement) {
                intersectionObserverRef.current.disconnect();
                setIsIntersecting(false);
            }
        } else {
            // If client doesnt support IntersectionObserver, set Intersecting to be true
            setIsIntersecting(true);
        }
        return function() {
            if (intersectionObserverRef.current) {
                intersectionObserverRef.current.disconnect();
            }
        };
    }, [
        observerRefElement
    ]);
    return {
        observerRef: setObserverRefElement,
        isIntersecting: isIntersecting
    };
};
/* harmony default export */ var hooks_useIntersectionObserver = (useIntersectionObserver);

// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(90915);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(92072);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-bottom: 32px;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Outer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-77de9e7a-0"
})(_templateObject(), function(param) {
    var theme = param.theme, background = param.background;
    return background || theme.colors.gradientBubblegum;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-77de9e7a-1"
})(_templateObject1());
var PageHeader = function(_param) /*#__PURE__*/ {
    var background = _param.background, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "background",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Outer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: children
        })
    }));
};
/* harmony default export */ var PageHeader_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/components/PageHeader/index.ts



// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx + 1 modules
var Input = __webpack_require__(25569);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/SearchInput/SearchInput.tsx


function SearchInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  margin-left: auto;\n"
    ]);
    SearchInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchInput_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    SearchInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-34897c3b-0"
})(SearchInput_templateObject());
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34897c3b-1"
})(SearchInput_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var SearchInput = function(param) {
    var onChangeCallback = param.onChange, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "Search" : _param_placeholder, initialValue = param.initialValue;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(""), 2), searchText = _useState[0], setSearchText = _useState[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var debouncedOnChange = (0,react.useMemo)(function() {
        return debounce_default()(function(e) {
            return onChangeCallback(e);
        }, 500);
    }, [
        onChangeCallback
    ]);
    var onChange = function(e) {
        setSearchText(e.target.value);
        debouncedOnChange(e);
    };
    (0,react.useEffect)(function() {
        if (initialValue) {
            setSearchText(initialValue);
        }
    }, [
        initialValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
            value: searchText,
            onChange: onChange,
            placeholder: t(placeholder)
        })
    });
};
/* harmony default export */ var SearchInput_SearchInput = (SearchInput);

;// CONCATENATED MODULE: ./src/components/SearchInput/index.ts


// EXTERNAL MODULE: ./src/components/Select/Select.tsx + 1 modules
var Select = __webpack_require__(24449);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(21270);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(60132);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/components/ScrollToTopButton/ScrollToTopButtonV2.tsx


function ScrollToTopButtonV2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  right: 5%;\n  bottom: calc(110px + env(safe-area-inset-bottom));\n"
    ]);
    ScrollToTopButtonV2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FixedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c40c406-0"
})(ScrollToTopButtonV2_templateObject());
var ScrollToTopButton = function() {
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), visible = _useState[0], setVisible = _useState[1];
    var scrollToTop = (0,react.useCallback)(function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(function() {
        var toggleVisible = function() {
            var scrolled = document.documentElement.scrollTop;
            if (scrolled > 500) {
                setVisible(true);
            } else if (scrolled <= 500) {
                setVisible(false);
            }
        };
        var throttledToggleVisible = throttle_default()(toggleVisible, 200);
        window.addEventListener("scroll", throttledToggleVisible);
        return function() {
            return window.removeEventListener("scroll", throttledToggleVisible);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContainer, {
        style: {
            display: visible ? "inline" : "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: 48,
            height: 48,
            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                color: "white",
                style: {
                    marginLeft: 0
                }
            }),
            onClick: scrollToTop
        })
    });
};
/* harmony default export */ var ScrollToTopButtonV2 = (ScrollToTopButton);

;// CONCATENATED MODULE: ./src/utils/latinise.ts
var Latinise = {
    latin_map: {
        τ: "t",
        Τ: "T"
    }
};
var latinise = function(input) {
    return input.replace(/[^A-Za-z0-9[\] ]/g, function(x) {
        return Latinise.latin_map[x] || x;
    });
};

// EXTERNAL MODULE: ./src/utils/sortGames.ts
var sortGames = __webpack_require__(15458);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(10806);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(67077);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(86016);
;// CONCATENATED MODULE: ./src/views/Games/components/GameTabButtons/index.tsx

function GameTabButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    GameTabButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var GameTabButtons = function(param) {
    var hasStakeInFinishedGames = param.hasStakeInFinishedGames;
    var router = (0,next_router.useRouter)();
    var t = (0,src/* useTranslation */.$G)().t;
    var activeIndex;
    switch(router.pathname){
        case "/games":
            activeIndex = 0;
            break;
        case "/games/history":
            activeIndex = 1;
            break;
        default:
            activeIndex = 0;
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
            activeIndex: activeIndex,
            scale: "sm",
            variant: "subtle",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                    as: NextLink/* NextLinkFromReactRouter */.a,
                    to: "/games",
                    children: t("Live")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                    show: hasStakeInFinishedGames,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        as: NextLink/* NextLinkFromReactRouter */.a,
                        to: "/games/history",
                        id: "finished-games-button",
                        children: t("History")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_GameTabButtons = (GameTabButtons);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df9ca020-0"
})(GameTabButtons_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(85719);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/CardFooter.tsx

function CardFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    CardFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
}).withConfig({
    componentId: "sc-cddac6ee-0"
})(CardFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, index_esm/* space */.Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ var Card_CardFooter = (CardFooter);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(77936);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(97374);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(94244);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/RocketIcon.tsx
var RocketIcon = __webpack_require__(49689);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(42037);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(98130);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(61328);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/views/Games/images/createGameCardImage.png
/* harmony default export */ var createGameCardImage = ({"src":"/_next/static/media/createGameCardImage.cb672292.png","height":4320,"width":4320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEVMaXHayJBjosbJaHG+aXnKIjJ4YaK2lNiwXHiM0efjuiwAqOtjk7S/Zn3Ps1iwYkLChGati6Tsk3FrjKiQmuvCazPTvDy+bBXWNULjiUW+gWLVGSmNk7ShjcabAQVPAAAAFnRSTlMAsmibU+74BxkeXimpMt1aZP5p3mdnmh/lEgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD1JREFUCJljYOBgZ4AAFgEGbiYQR1RSSJgHJMIvJSgrAmJwsrHJ8HGxMzBwsEqLizEygBgSzJxgbbwsIAoARYIB6gjRVVMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Games/components/CreateGameCard.tsx


function CreateGameCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  margin-top: 10px;\n  ",
        " {\n    width: 296px;\n    margin-left: 50px;\n  }\n  ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    CreateGameCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CreateGameCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: -50px;\n  transform: translateY(-50%) scale(75%);\n  right: 10px;\n  ",
        " {\n    right: auto;\n    top: 50%;\n    left: -90px;\n    transform: translateY(-45%);\n  }\n  z-index: 2;\n"
    ]);
    CreateGameCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: none;\n  position: relative;\n  padding: 8px 24px 16px;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: calc(100% - 48px);\n    top: 0px;\n    left: 24px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var CardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9713660c-0"
})(CreateGameCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9713660c-1"
})(CreateGameCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-9713660c-2"
})(_templateObject2());
var StyledCardFooter = (0,styled_components_browser_esm/* default */.ZP)(Card_CardFooter).withConfig({
    componentId: "sc-9713660c-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var useBCakeTooltipContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var tooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: t("More infos on game creation soon")
        })
    });
    return tooltipContent;
};
var CreateGameCard = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var tooltipContent = useBCakeTooltipContent();
    var _useTooltip = (0,useTooltip/* default */.Z)(tooltipContent, (0,_object_spread/* default */.Z)({
        placement: "bottom-start"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = _useTooltip.targetRef, tooltip = _useTooltip.tooltip, tooltipVisible = _useTooltip.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: createGameCardImage,
                    alt: "createGameCardImage",
                    width: 150,
                    height: 150,
                    placeholder: "blur"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                p: "0px",
                style: {
                    zIndex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardBody, {
                        style: {
                            padding: "15px 24px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketIcon/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: 22,
                                bold: true,
                                color: "text",
                                marginBottom: "-12px",
                                display: "inline-block",
                                ml: "7px",
                                children: t("Create Game")
                            }),
                            tooltipVisible && tooltip,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ref: targetRef,
                                style: {
                                    float: "right",
                                    position: "relative",
                                    top: "6px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    color: theme.colors.textSubtle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardFooter, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, {})
                    })
                ]
            })
        ]
    });
};
var CardContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    if (!account) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Connect wallet to create a new game")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("Game will be associated to your address as you can win some fee")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                width: "100%",
                style: {
                    backgroundColor: theme.colors.textSubtle
                }
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Create a new game")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term CAKE staking position is required for activating game yield boosters.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/game/create",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    as: "a",
                    width: "100%",
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    },
                    children: t("Create Game")
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Games/Games.tsx


function Games_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  position: relative;\n\n  justify-content: space-between;\n  flex-direction: column;\n  margin-bottom: 32px;\n\n  ",
        " {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 16px 32px;\n    margin-bottom: 0;\n  }\n"
    ]);
    Games_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Games_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  ",
        " {\n    flex-wrap: nowrap;\n  }\n"
    ]);
    Games_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Games_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  margin-bottom: 8px;\n  ",
        " {\n    font-size: 64px;\n    margin-bottom: 24px;\n  }\n"
    ]);
    Games_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Games_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin-bottom: 8px;\n  ",
        " {\n    font-size: 24px;\n    margin-bottom: 18px;\n  }\n"
    ]);
    Games_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n\n  ",
        " {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 0px;\n\n  ",
        " {\n    width: auto;\n    padding: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  justify-content: space-between;\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  > div {\n    padding: 8px 0px;\n  }\n\n  ",
        " {\n    justify-content: flex-start;\n    width: auto;\n\n    > div {\n      padding: 0;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 32px;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  white-space: nowrap;\n  text-decoration: underline;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






















var ControlContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96f0b0d9-0"
})(Games_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var GameFlexWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-96f0b0d9-1"
})(Games_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var GameH1 = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-96f0b0d9-2"
})(Games_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var GameH2 = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-96f0b0d9-3"
})(Games_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96f0b0d9-4"
})(_templateObject4(), Text/* default */.Z);
var LabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96f0b0d9-5"
})(_templateObject5(), Text/* default */.Z);
var FilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96f0b0d9-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var ViewControls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-96f0b0d9-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var FinishedTextContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-96f0b0d9-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FinishedTextLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-96f0b0d9-9"
})(_templateObject9());
var NUMBER_OF_GAMES_VISIBLE = 12;
var Games = function(param) {
    var children = param.children;
    var _useRouter = (0,next_router.useRouter)(), pathname = _useRouter.pathname, urlQuery = _useRouter.query;
    var t = (0,src/* useTranslation */.$G)().t;
    // TODO GUIGUI update hook
    var _useGames = (0,hooks/* useGames */.ek)(), games = _useGames.data, userDataLoaded = _useGames.userDataLoaded;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(""), 2), _query = _useState[0], setQuery = _useState[1];
    var normalizedUrlSearch = (0,react.useMemo)(function() {
        return typeof (urlQuery === null || urlQuery === void 0 ? void 0 : urlQuery.search) === "string" ? urlQuery.search : "";
    }, [
        urlQuery
    ]);
    var query = normalizedUrlSearch && !_query ? normalizedUrlSearch : _query;
    //   const [viewMode, setViewMode] = useUserGamesViewMode()
    //   const { account } = useWeb3React()
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)("playing"), 2), sortOption = _useState1[0], setSortOption = _useState1[1];
    var _useIntersectionObserver = hooks_useIntersectionObserver(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var chosenGamesLength = (0,react.useRef)(0);
    var isMyGames = pathname.includes("my-games");
    var isDeleted = pathname.includes("history");
    var isActive = !isDeleted;
    (0,hooks/* usePollGamesWithUserData */.JR)();
    // Users with no wallet connected should see 0 as Earned amount
    // Connected users should see loading indicator until first userData has loaded
    //   const userDataReady = !account || (!!account && userDataLoaded)
    // TODO GUIGUI FIRST HANDLE FILTERS
    var _useState2 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isNotFullOnly = _useState2[0], setNotFullOnly = _useState2[1];
    var _useState3 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), myPlayingGamesOnly = _useState3[0], setMyPlayingGamesOnly = _useState3[1];
    var activeGames = games.filter(function(game) {
        return !isMyGames ? !game.isPaused && !game.isDeleted : !game.isDeleted;
    }).sort(sortGames/* sortGamesDefault */.J);
    var notFullGames = games.filter(function(game) {
        return !game.isInProgress && game.maxPlayers.toNumber() !== game.playerAddressesCount.toNumber();
    });
    var playingOnlyGames = games.filter(function(game) {
        return game.userData && game.userData.isPlaying;
    });
    var mineOnlyGames = games.filter(function(game) {
        return game.userData && game.userData.isCreator && !game.isPaused;
    });
    var deletedGames = games.filter(function(game) {
        return game.isDeleted || game.isPaused;
    });
    var myDeletedGames = games.filter(function(game) {
        return game.isDeleted || game.isPaused && game.userData && game.userData.isCreator;
    });
    // const archivedGames = archivedGames.filter((game) => game.userData && false)
    // TODO update gameList with GameList
    // TODO GUIGUI UPDATE GameWithStakedValue INTERFACE TO GAME INTERFACE
    var gamesList = (0,react.useCallback)(function(gamesToDisplay) {
        var gamesToDisplayWithAPR = gamesToDisplay.map(function(game) {
            return game;
        });
        if (query) {
            var lowercaseQuery = latinise(query.toLowerCase());
            gamesToDisplayWithAPR = gamesToDisplayWithAPR.filter(function(game) {
                return latinise(game.name.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return gamesToDisplayWithAPR;
    }, [
        query
    ]);
    var handleChangeQuery = function(event) {
        setQuery(event.target.value);
    };
    var _useState4 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(NUMBER_OF_GAMES_VISIBLE), 2), numberOfGamesVisible = _useState4[0], setNumberOfGamesVisible = _useState4[1];
    var chosenGames = (0,react.useMemo)(function() {
        var chosenFs = [];
        if (isActive) {
            chosenFs = gamesList(activeGames);
        }
        if (isDeleted) {
            if (isMyGames) chosenFs = gamesList(myDeletedGames);
            else chosenFs = gamesList(deletedGames);
        }
        if (isNotFullOnly) {
            chosenFs = gamesList(notFullGames);
        }
        if (myPlayingGamesOnly) {
            chosenFs = gamesList(playingOnlyGames);
        }
        if (isMyGames) {
            chosenFs = gamesList(mineOnlyGames);
        }
        return chosenFs.sort(sortGames/* sortGamesDefault */.J);
    }, [
        isActive,
        isDeleted,
        isMyGames,
        isNotFullOnly,
        myPlayingGamesOnly,
        gamesList,
        activeGames,
        myDeletedGames,
        deletedGames,
        notFullGames,
        playingOnlyGames,
        mineOnlyGames
    ]);
    var chosenGamesMemoized = (0,react.useMemo)(function() {
        var sortGames = function(gamesToSort) {
            switch(sortOption){
                case "players":
                    return orderBy_default()(gamesToSort, function(game) {
                        return game.playerAddressesCount;
                    }, "desc");
                case "prize":
                    return orderBy_default()(gamesToSort, function(game) {
                        return game.registrationAmount ? Number(game.registrationAmount) : 0;
                    }, "desc");
                case "playing":
                    return orderBy_default()(gamesToSort, function(game) {
                        return Number(game.userData.isPlaying);
                    }, "desc");
                case "latest":
                    return orderBy_default()(gamesToSort, function(game) {
                        return Number(game.id);
                    }, "desc");
                default:
                    return gamesToSort;
            }
        };
        return sortGames(chosenGames).slice(0, numberOfGamesVisible);
    }, [
        chosenGames,
        sortOption,
        numberOfGamesVisible
    ]);
    chosenGamesLength.current = chosenGamesMemoized.length;
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setNumberOfGamesVisible(function(gamesCurrentlyVisible) {
                if (gamesCurrentlyVisible <= chosenGamesLength.current) {
                    return gamesCurrentlyVisible + NUMBER_OF_GAMES_VISIBLE;
                }
                return gamesCurrentlyVisible;
            });
        }
    }, [
        isIntersecting
    ]);
    var handleSortOptionChange = function(option) {
        setSortOption(option.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GamesContext.Provider, {
        value: {
            chosenGamesMemoized: chosenGamesMemoized
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader_PageHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GameFlexWrapper, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GameH1, {
                                    as: "h1",
                                    scale: "xxl",
                                    color: "secondary",
                                    mb: "24px",
                                    children: isMyGames ? t("My Games") : t("Games")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GameH2, {
                                    scale: "lg",
                                    color: "text",
                                    children: t("Register to a game to start playing.")
                                }),
                                isMyGames ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                    to: "/games",
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "primary",
                                                bold: true,
                                                fontSize: "16px",
                                                mr: "4px",
                                                children: t("All Games")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                color: "primary"
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                    to: "/games/my-games",
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "primary",
                                                bold: true,
                                                fontSize: "16px",
                                                mr: "4px",
                                                children: t("My Created Games")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                                color: "primary"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateGameCard, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ControlContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewControls, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                id: "my-games-only",
                                                checked: myPlayingGamesOnly,
                                                onChange: function() {
                                                    return setMyPlayingGamesOnly(function(prev) {
                                                        return !prev;
                                                    });
                                                },
                                                scale: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    " ",
                                                    t("Playing only")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                                                id: "not-full-games",
                                                checked: isNotFullOnly,
                                                onChange: function() {
                                                    return setNotFullOnly(!isNotFullOnly);
                                                },
                                                scale: "sm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    " ",
                                                    t("Registering only")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GameTabButtons, {
                                        hasStakeInFinishedGames: myDeletedGames.length > 0 && isMyGames
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Sort by")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                options: [
                                                    {
                                                        label: t("Playing"),
                                                        value: "playing"
                                                    },
                                                    {
                                                        label: t("Players"),
                                                        value: "players"
                                                    },
                                                    {
                                                        label: t("Prize"),
                                                        value: "prize"
                                                    },
                                                    {
                                                        label: t("Latest"),
                                                        value: "latest"
                                                    }
                                                ],
                                                onOptionChange: handleSortOptionChange
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                        style: {
                                            marginLeft: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textTransform: "uppercase",
                                                children: t("Search")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput_SearchInput, {
                                                initialValue: normalizedUrlSearch,
                                                onChange: handleChangeQuery,
                                                placeholder: "Search Games"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Flex/* default */.Z, {
                        children: children
                    }),
                    !chosenGamesMemoized.length && isMyGames && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishedTextContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: [
                                    "16px",
                                    null,
                                    "20px"
                                ],
                                color: "failure",
                                pr: "4px",
                                children: t("You haven't created any games yet")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishedTextLink, {
                                    href: "/game/create",
                                    fontSize: [
                                        "16px",
                                        null,
                                        "20px"
                                    ],
                                    color: "failure",
                                    children: t("Create a new game")
                                })
                            })
                        ]
                    }),
                    !chosenGamesMemoized.length && !userDataLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    }),
                    userDataLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: observerRef
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButtonV2, {}), document.body)
        ]
    });
};
var GamesContext = /*#__PURE__*/ (0,react.createContext)({
    chosenGamesMemoized: []
});
/* harmony default export */ var Games_Games = (Games);

;// CONCATENATED MODULE: ./src/views/Games/index.tsx


var GamesPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Games_Games, {
        children: children
    });
};



/***/ })

}]);